<template>
  <img v-if="fileType === 'pdf'" class="icon-item" src="@/assets/images/file/pdf.png" />
  <img v-else-if="fileType === 'mp3'" class="icon-item" src="@/assets/images/file/mp3.png" />
  <img v-else-if="fileType === 'mp4'" class="icon-item" src="@/assets/images/file/mp4.png" />
  <img v-else-if="fileType === 'txt'" class="icon-item" src="@/assets/images/file/txt.png" />
  <img v-else-if="fileType === 'zip'" class="icon-item" src="@/assets/images/file/zip.png" />
  <img v-else-if="isImage" class="icon-item" src="@/assets/images/file/image.png" />
  <img v-else-if="isVideo" class="icon-item" src="@/assets/images/file/video.png" />
  <img v-else-if="isWord" class="icon-item" src="@/assets/images/file/word.png" />
  <img v-else-if="isExcel" class="icon-item" src="@/assets/images/file/excel.png" />
  <img v-else-if="isPPT" class="icon-item" src="@/assets/images/file/ppt.png" />
  <img v-else-if="isWPSWord" class="icon-item" src="@/assets/images/file/wps-doc.png" />
  <img v-else-if="isWPSExcel" class="icon-item" src="@/assets/images/file/wps-excel.png" />
  <img v-else class="icon-item" src="@/assets/images/file/other.png" />
</template>

<script>
export default {
  name: 'IconFileType',
  props: {
    fileName: {
      type: String,
      default: ''
    }
  },
  computed: {
    fileType() {
      const fileName = this.fileName?.toLocaleLowerCase() || ''
      const fileType = this.extractFilePostfix(fileName)
      return fileType
    },
    isImage() {
      const imageFileTypes = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp']
      return imageFileTypes.includes(this.fileType)
    },
    isVideo() {
      const videoFileTypes = ['mp4', 'avi', 'mkv', 'mov', 'wmv']
      return videoFileTypes.includes(this.fileType)
    },
    isWord() {
      const wordDocumentFileTypes = ['doc', 'docx']
      return wordDocumentFileTypes.includes(this.fileType)
    },
    isExcel() {
      const excelFileTypes = ['xls', 'xlsx']
      return excelFileTypes.includes(this.fileType)
    },
    isPPT() {
      const powerPointFileTypes = ['ppt', 'pptx']
      return powerPointFileTypes.includes(this.fileType)
    },
    isWPSExcel() {
      const wpsExcelFileTypes = ['et']
      return wpsExcelFileTypes.includes(this.fileType)
    },
    isWPSWord() {
      const wpsWordFileTypes = ['wps']
      return wpsWordFileTypes.includes(this.fileType)
    },
    isWPSPPT(fileName) {
      const wpsPPTFileTypes = ['wpp', 'dpt', 'dps']
      return wpsPPTFileTypes.includes(this.fileType)
    }
  },
  methods: {
    extractFilePostfix(fileName) {
      const parts = fileName.split('.')
      if (parts.length > 1) {
        return parts[parts.length - 1]
      } else {
        return ''
      }
    }
  }
}
</script>

<style>
.icon-item {
  width: 20px;
  height: 20px;
  margin-right: 12px;
  flex-shrink: 0;
}
</style>
